var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"title":"Pranešimų nustatymai","subtitle":"Čia galite redaguoti el. laiškų ar sms nustatymus"}}),_c('DataTable',{attrs:{"table":_vm.table}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }